import { jsx as _jsx } from "react/jsx-runtime";
import { useStylesV2 } from '@kubit/web-ui-components/hooks/useStyles';
import React, { useRef } from 'react';
import { STYLES_NAME } from '../../constants/stylesName/stylesName';
import { useBottom } from './hooks/useBottom';
import { usePDFPages } from './hooks/usePDFPages';
import { PDFViewerStandAlone } from './pdfViewerStandAlone';
export const PDFViewer = React.forwardRef(({ variant, ctv, pdfUrl, pdfScale = 1, onRenderComplete, onBottomReached, onError, ...props }, ref) => {
    const innerRef = useRef(null);
    React.useImperativeHandle(ref, () => innerRef.current, []);
    const styles = useStylesV2({
        styleName: STYLES_NAME.PDF_VIEWER,
        variantName: variant,
        customTokens: ctv,
    });
    // Custom hook for observing the bottom of the PDF (bottomReached)
    // and handling the scroll to the bottom of the PDF
    const { bottomReached, handleScrollToBottom } = useBottom({
        ref: innerRef,
        onBottomReached,
    });
    // Custom hook for rendering PDF pages
    const { pagesTextContent, error } = usePDFPages({
        pdfUrl,
        pdfScale,
        onRenderComplete,
        onError,
        ref: innerRef,
    });
    if (error) {
        return null;
    }
    return (_jsx(PDFViewerStandAlone, { ref: innerRef, ...props, bottomContent: props.bottomContent, pagesTextContent: pagesTextContent, pdfScale: pdfScale, scrollAtBottom: bottomReached, styles: styles, onScrollToBottom: handleScrollToBottom }));
});
PDFViewer.displayName = 'PDFViewer';
//# sourceMappingURL=pdfViewer.js.map